import React from "react";
import { containerClassName } from "@/lib/container";

const SERVICES_LINKS = [
  { id: "f-svc-cloud", label: "Cloud", href: "#services" },
  { id: "f-svc-enterprise", label: "Enterprise IT", href: "#services" },
  { id: "f-svc-managed", label: "Managed Services", href: "#services" },
  { id: "f-svc-github", label: "GitHub & Copilot", href: "#services" },
  { id: "f-svc-ai", label: "Agentic AI", href: "#services" },
  { id: "f-svc-hiring", label: "Hiring Solutions", href: "#hiring" },
  { id: "f-svc-consulting", label: "IT Consulting", href: "#approach" },
];

const COMPANY_LINKS = [
  { id: "f-co-contact", label: "Contact", href: "#contact" },
  { id: "f-co-faq", label: "FAQ", href: "#faq" },
  { id: "f-co-privacy", label: "Privacy Policy", href: "#" },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-zinc-950 text-white border-t border-white/10"
    >
      <div className={containerClassName}>
        <div className="py-10 lg:py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-x-10 lg:gap-y-6">
          <div className="sm:col-span-2 lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <img
                src="/logo.png"
                alt="Conquest IT Services"
                className="w-10 h-10 object-contain"
              />
              <span
                className="text-base font-black tracking-tight text-white"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                Conquest IT Services
              </span>
            </div>
            <p className="mt-3 text-sm text-zinc-400 max-w-xs leading-relaxed">
              Empowering businesses through technology.
            </p>
            <p
              data-testid="footer-wordmark"
              className="mt-5 text-xs uppercase tracking-[0.35em] text-zinc-600 font-semibold"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Conquest
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.22em] text-zinc-500 font-semibold">
              Services
            </div>
            <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
              {SERVICES_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={l.href}
                    data-testid={l.id}
                    className="text-sm text-zinc-300 hover:text-white transition-colors duration-200"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-zinc-500 font-semibold">
              Company
            </div>
            <ul className="mt-3 space-y-2">
              {COMPANY_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={l.href}
                    data-testid={l.id}
                    className="text-sm text-zinc-300 hover:text-white transition-colors duration-200"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="py-5 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-zinc-500">
          <div>Conquest IT Services © {year} — All rights reserved</div>
          <div className="text-zinc-600">
            Built for businesses that can’t afford downtime.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
